import { createI18n } from 'vue-i18n'
import en from './en'
import zh from './zh'
import fil from '../locales/fil'
import id from '../locales/id'
import th from '../locales/th'
import vi from '../locales/vi'

const messages = {
  en,
  zh,
  'zh-CN': zh,
  'zh-HK': zh,
  'zh-TW': zh,
  fil,
  id,
  th,
  vi
}

const savedLocale = localStorage.getItem('locale')

const i18n = createI18n({
  legacy: false,
  locale: savedLocale || 'en',
  fallbackLocale: 'en',
  messages
})

export default i18n

export function setLocale(locale: string) {
  i18n.global.locale.value = locale as any
  localStorage.setItem('locale', locale)
  document.documentElement.lang = locale
}

export function getLocale(): string {
  return i18n.global.locale.value as string
}

export const availableLocales = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'zh', name: '繁體中文', nativeName: '繁體中文' },
  { code: 'zh-CN', name: '简体中文', nativeName: '简体中文' },
  { code: 'fil', name: 'Filipino', nativeName: 'Filipino' },
  { code: 'id', name: 'Indonesian', nativeName: 'Bahasa Indonesia' },
  { code: 'th', name: 'Thai', nativeName: 'ไทย' },
  { code: 'vi', name: 'Vietnamese', nativeName: 'Tiếng Việt' }
]

export function getLocaleName(code: string): string {
  const locale = availableLocales.find(l => l.code === code)
  return locale?.nativeName ?? code
}
